// extracted by mini-css-extract-plugin
export default {"container":"addTournamentDetailsTemplate_container__N5Uoq","displayContainer":"addTournamentDetailsTemplate_displayContainer__iyyBV"};